import { AxiosInstance } from 'axios';

export interface PromptAnalyticsResponse {
  domain_id: string;
  analysis_date: string;
  total_prompts: number;
  total_usage_records: number;
  unique_users: number;
  most_used_prompts: MostUsedPrompt[];
  categories: Category[];
  most_active_users: MostActiveUser[];
  processing_time_seconds: number;
  error_count: number;
  errors: string[];
}

export interface MostUsedPrompt {
  prompt_id: string | null;
  prompt_text: string;
  usage_count: number;
  unique_users: number;
  first_used: string;
  last_used: string;
  is_custom: boolean;
}

export interface Category {
  category: string;
  prompt_count: number;
  usage_count: number;
  unique_users: number;
  top_prompts: string[];
  optimization_suggestions: OptimizationSuggestion[];
  consolidation_suggestions: ConsolidationSuggestion[];
  library_prompt_matches: any[];
}

export interface OptimizationSuggestion {
  original_prompt: string;
  optimized_prompt: string;
  improvements: string[];
  reasoning: string;
}

export interface ConsolidationSuggestion {
  similar_prompts: string[];
  consolidated_prompt: string;
  rationale: string;
  estimated_usage: number;
}

export interface MostActiveUser {
  email: string;
  prompt_count: number;
  unique_prompts: number;
  custom_prompt_count: number;
  categories: string[];
  most_used_prompts: string[];
  first_activity: string;
  last_activity: string;
}

export type IntervalKeyword = '1w' | '2w' | '3w' | '1m' | '2m' | '3m';

export interface RecentHistoryResponse {
  prompts: UserHistoryPrompt[];
  total_count: number;
  status: string;
}

export interface UserHistoryPrompt {
  prompt_text: string;
  timestamp?: string;
  [key: string]: any;
}

export class PromptAnalyticsApi {
  constructor(private axiosInstance: AxiosInstance) {}

  async getLatestReport(
    domainId: string,
    interval: IntervalKeyword = '3m',
  ): Promise<PromptAnalyticsResponse> {
    const response = await this.axiosInstance.get(
      `/aiservice/secure/prompts/analytics/reports/latest/${domainId}/${interval}`,
    );
    return response.data;
  }

  async getRecentHistory(
    emailId: string,
    domainId: string,
    count: number = 100,
  ): Promise<RecentHistoryResponse> {
    const response = await this.axiosInstance.get(
      `/aiservice/secure/recent_history`,
      {
        params: {
          emailid: emailId,
          domainid: domainId,
          count,
        },
      },
    );
    return response.data;
  }
}
